<template>
  <div class="col col_1_of_3">  
    <!-- TO DO customer gift -->  
    <div class="weAcceptRight"><img src="https://translationpal.com/imgs/2015/credit_cards.png" alt="" style="width:477px;height:156px;"></div>
    <!--Begin Comm100 Live Chat Code-->
    <div id="comm100-button-2593"  class="weAcceptRight"></div>
    <!--End Comm100 Live Chat Code-->
    <div class="secureRight"><img src="https://translationpal.com/imgs/2015/two-professional-proofreaders.png" alt="" style="width:320px;height:128px;"></div>
    
    <div class="rightTestimonial rightTestimonialHidden" id="mlaTestimonial">
        <p>"Super helpful! My certificate was translated into English accurately and delivered back on time."</p>
        <span class="author">Tyler Kerr</span>
    </div>

    <div class="weAcceptRight">
        <img src="https://translationpal.com/imgs/2015/guarantee-100.png" alt="" style="width:87px;height:87px;">
    </div>

  </div>
</template>

<script>
import '@/assets/js/chatButton.js'
</script>

<style>

</style>